import { Injectable } from '@angular/core';
import { select, Store, Action } from '@ngrx/store';

import * as fromLabReq from './lab-req.reducer';
import * as LabReqSelectors from './lab-req.selectors';
import * as LabReqActions from './lab-req.actions';

@Injectable()
export class LabReqFacade {
  loading$ = this.store.pipe(select(LabReqSelectors.getLabReqLoading));
  allLabReq$ = this.store.pipe(select(LabReqSelectors.getAllLabReq));
  selectedLabReq$ = this.store.pipe(select(LabReqSelectors.getSelected));

  constructor(private store: Store<fromLabReq.LabReqPartialState>) {}

  dispatch(action: Action) {
    this.store.dispatch(action);
  }

  loadLabReq(_id: string) {
    this.dispatch(LabReqActions.loadLabReq({ _id }));
  }

  loadPatientLabReqs(filters?: any) {
    this.dispatch(LabReqActions.loadPatientLabReqs(filters));
  }

  loadLatestLabReq() {
    this.dispatch(LabReqActions.loadLatestLabReq());
  }
}
